import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "catalog-products catalog-products--list" };
const _hoisted_2 = { class: "catalog-products__search" };
const _hoisted_3 = { class: "catalog-products__title" };
const _hoisted_4 = {
    key: 0,
    class: "catalog-products__controls"
};
const _hoisted_5 = { class: "catalog-products__totals" };
const _hoisted_6 = { class: "catalog-products__actions" };
const _hoisted_7 = { class: "catalog-products__results" };
const _hoisted_8 = {
    key: 0,
    class: "catalog-products__list"
};
const _hoisted_9 = {
    key: 0,
    class: "alert alert--warning"
};
import { ref, computed } from 'vue';
import CatalogListItem from "./CatalogListItem.vue";
import CatalogProductsBulkSearchInput from "./CatalogProductsBulkSearchInput.vue";
import AddCartItems from "../commands/AddCartItems";
import CommandButton from '@astina/paloma-common-ui/src/components/CommandButton.vue';
import trans from "@astina/paloma-common-ui/src/services/Translator";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogProductsBulkSearch',
    setup(__props) {
        const products = ref(null);
        const itemDrafts = ref([]);
        const addCartItems = computed(() => {
            return new AddCartItems(itemDrafts.value);
        });
        const addCartItemsLabel = computed(() => {
            // sum quantities per unit
            const quantities = {};
            itemDrafts.value.forEach(itemDraft => {
                const unit = itemDraft.unit || 'piece';
                if (quantities[unit] === undefined) {
                    quantities[unit] = 0;
                }
                quantities[unit] += (itemDraft.quantity);
            });
            const quantityWithUnits = [];
            for (let unit in quantities) {
                const unitLabel = trans('unit.' + unit, undefined, unit);
                const quantity = quantities[unit];
                quantityWithUnits.push(trans('catalog.bulk_search.add_items', { quantity, unit: unitLabel }));
            }
            return quantityWithUnits.join(' / ');
        });
        function onSearchResults(page) {
            itemDrafts.value = [];
            products.value = page;
            if (page.parsedSku.length === 0) {
                alerts.warning(trans('catalog.bulk_search.no_sku_found'));
            }
            // only do this if we aren't truncated, otherwise the matched/unmatched list is useless
            else if (!page.truncated) {
                if (page.matchedSku.length > 0) {
                    alerts.success(trans('catalog.bulk_search.sku_found', { count: page.matchedSku.length }));
                }
                if (page.unmatchedSku.length > 0) {
                    alerts.warning(trans('catalog.bulk_search.sku_not_found', {
                        count: page.unmatchedSku.length,
                        skus: page.unmatchedSku.join(', '),
                    }));
                }
            }
        }
        function onSearchStart() {
            products.value = null;
        }
        function onCartItemDraftChange(item) {
            const existing = itemDrafts.value.find(i => i.sku === item.sku);
            if (existing) {
                itemDrafts.value.splice(itemDrafts.value.indexOf(existing), 1);
            }
            itemDrafts.value.push(item);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('catalog.bulk_search')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(CatalogProductsBulkSearchInput, {
                        onSearchStart: onSearchStart,
                        onSearchResults: onSearchResults
                    })
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (products.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('catalog.bulk_search.sku_count', { count: products.value.matchedSku.length })), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(CommandButton, {
                                command: addCartItems.value,
                                label: addCartItemsLabel.value,
                                disabled: itemDrafts.value.length === 0
                            }, null, 8, ["command", "label", "disabled"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    (products.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (products.value.truncated)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('catalog.bulk_search.results_truncated', { max: products.value.size })), 1))
                                : _createCommentVNode("", true),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value.content, (product) => {
                                return (_openBlock(), _createBlock(CatalogListItem, {
                                    class: "catalog-products__list-item",
                                    item: product,
                                    "view-mode": "bulk",
                                    key: product.id,
                                    onCartItemDraftChange: onCartItemDraftChange
                                }, null, 8, ["item"]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
